import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SubPortfolioRisksRoutingModule } from './sub-portfolio-risks-routing.module';
import { SubPortfolioRisksComponent } from './sub-portfolio-risks.component';
import { FormsModule } from '@angular/forms';
import { DxDataGridModule } from 'devextreme-angular';
import { I18nModule } from "app/shared/i18n/i18n.module";
import { MaterialModule } from 'app/material.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { CurrencyFormatterPipeModule } from 'app/shared/currency-formatter-pipe/currencyFormatterPipe.module';


@NgModule({
  declarations: [SubPortfolioRisksComponent],
  imports: [
    CommonModule,
    DxDataGridModule,
    I18nModule,
    MaterialModule,
    FormsModule,
    NgxSpinnerModule,
    CurrencyFormatterPipeModule,
    SubPortfolioRisksRoutingModule
  ]
})
export class SubPortfolioRisksModule { }
